import { render } from "./CpsOverview.vue?vue&type=template&id=3f47358e&scoped=true&ts=true"
import script from "./CpsOverview.vue?vue&type=script&lang=ts"
export * from "./CpsOverview.vue?vue&type=script&lang=ts"

import "./CpsOverview.vue?vue&type=style&index=0&id=3f47358e&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/bouwstenen/Bouwsteen_BuildAndDeploy_Vue_Frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f47358e"]])

export default __exports__